const DarkModes = {
  CLEAR_MODE: 'clear-mode',
  DARK_MODE: 'dark-mode',
  LIGHT_MODE: 'light-mode',
};

export { DarkModes };
